export default "__VITE_ASSET__CSguOKbM__"